<div class="error-container">
    <div class="ui red segment segment">
        <p>
            <i class="red icon frown outline"></i>
            An error occurred while loading this component. Please refresh the page and try again, or contact
            hello@calendarhero.com for assistance.
        </p>
    </div>
</div>
